import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from 'src/app/apv/core/services/modal/modal.service';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { MODIFY_AMOUNT, CURRENCY } from './modify-amount.constants';
import { BffService } from '../../../core/services/http/bff.http.service';
import { GlobalStorage } from '../../../core/services/globals.service';
import { toClp } from '../../../core/utils/formatters';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { ICurrentSubscription } from 'src/app/shared/interfaces/subscription.interface';
import { MAIL_REGEX, IS_FAILED_SUBSCRIPTION} from 'src/app/shared/common/constants';
import { customRutFormValidator } from 'src/app/apv/core/utils/functions';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicStorageService } from 'src/app/apv/core/services/storage/ionic/storage.service';

@Component({
    selector: 'modify-amount',
    templateUrl: './modify-amount.component.html',
    styleUrls: ['./modify-amount.component.scss'],
    standalone: false
})
export class ModifyAmountModalComponent implements OnInit, OnDestroy{
  constructor(
    private readonly modalSvc: ModalService,
    public formBuilder: FormBuilder,
    private readonly bffSvc: BffService,
    private readonly globalSvc: GlobalStorage,
    private readonly router: Router,
    private readonly ionicStorage: IonicStorageService,
    private readonly route: ActivatedRoute,
    
  ) {}

  modifyAmount = MODIFY_AMOUNT;
  currency = CURRENCY;
  isLinear = true;
  isEditable = true;
  isCurrencyFocused = false;
  isFundsHovered = false;
  ufValue: string = '';
  subscriptionDataToModify!: ICurrentSubscription;
  frmModifyAmount!: FormGroup;
  subscriptionData: string = '';
  newAmount: string = '';
  subscriptionDataDiscount: string = '';
  newDiscount: string = '';
  isModifySubscriptionButtonDisabled = false;
  isExecutiveHelp: boolean = false;
  isExecutive: boolean = false;
  public showConfirmationWindowBool: boolean = false;
  public helperTextCurrentDiscount: string = '';
  isFocusButtonSecondary: boolean = false;
  isFocusRadioPills: boolean = false;
  isFocusReadioExecutive: boolean = false;

  ngOnInit(): void {
    this.getDataFromStorage();
    this.getDataFromStorageAmount();
    this.frmModifyAmount = this.formBuilder.group({
      currency: [
        this.typeDiscount(),
        Validators.compose([Validators.required]),
      ],
      amount: [this.amount(), Validators.compose([Validators.required])],
      email: [
        this.subscriptionDataToModify.employerEmail,
        Validators.compose([
          Validators.required,
          Validators.pattern(MAIL_REGEX),
        ]),
      ],
      executiveHelp: [this.isExecutiveHelp],
    });
    this.checkQueryParams();
    this.addDeleteValidatorAmount();
    this.setHelperTextDiscount();
  }
  ngOnDestroy(): void {
    this.removeDataFromStorage();
  }
  private checkQueryParams(): void {
    this.route.queryParams.subscribe(params => {
      if (params['amount'] && params['currency']) {
        // Inicializar el formulario con los params recibidos
        this.frmModifyAmount.patchValue({
          amount: params['amount'],
          currency: params['currency'] === 'U' ? 'uf' : 'pesos'
        });
      }
    });
  }
  currencyChangeFocus() {
    this.isCurrencyFocused = !this.isCurrencyFocused;
  }

  keyPressNumbers(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  frmSubmit(frm: FormGroup) {
    console.log(frm);
  }

  public unitModify() {
    switch (this.subscriptionDataToModify.discountType) {
      case 'U':
        return 'uf';
      case 'P':
        return 'pesos';
      case 'R':
        return 'porcentaje';
      default:
        return '';
    }
  }

  public amount() {
    return this.newAmount
      ? this.newAmount
      : `${this.subscriptionDataToModify.discountValue}`;
  }

  public typeDiscount() {
    return this.newDiscount ? this.newDiscount : this.unitModify();
  }

  isValidAmount(): boolean {
    if (this.frmModifyAmount.get('amount')?.errors) return true;
    return false;
  }
  public numberToCurrency(number: string) {
    // max digits 9
    if (number.length > 9) {
      number = number.slice(0, 9);
    }
    // dont allow decimals numbers
    if (number.startsWith('0')) {
      number = number.substring(1); 
    }
    if (number) {
      const numberWithDots = toClp(Number(number));
      return numberWithDots;
    }
    return '';
  }

  addDotsToNumber(event: any) {
    const number = event.target.value.toString().replaceAll('.', '');

    //maximo 2 caracteres para uf
    if (
      (this.frmModifyAmount.value.currency === 'uf' && number.length > 2) ||
      (this.frmModifyAmount.value.currency === 'porcentaje' &&
        number.length > 2)
    ) {
      this.frmModifyAmount.get('amount')?.setValue(number.slice(0, 2));
      return;
    }

    const numberWithDots = this.numberToCurrency(number);
    this.frmModifyAmount.get('amount')?.setValue(numberWithDots);
  }

  isValidInputAmount(): string {
    if (this.isValidAmount()) return 'on-input-error';
    return '';
  }

  isValidAmountPesos(): boolean {
    return (
      this.isValidAmount() && this.frmModifyAmount.value.currency === 'pesos'
    );
  }

  isValidAmountUF(): boolean {
    return this.isValidAmount() && this.frmModifyAmount.value.currency === 'uf';
  }

  isValidAmountPorcentaje(): boolean {
    return (
      this.isValidAmount() &&
      this.frmModifyAmount.value.currency === 'porcentaje'
    );
  }

  displayUfValue(): boolean {
    return (
      !this.isValidAmount() && this.frmModifyAmount.value.currency === 'uf'
    );
  }

  changeCurrency() {
    this.frmModifyAmount.get('amount')?.setValue('');
  }

  addDeleteValidatorAmount() {
    switch (this.frmModifyAmount.get('currency')?.value) {
      case 'uf':
        this.frmModifyAmount
          .get('amount')
          ?.setValidators([
            Validators.required,
            Validators.maxLength(2),
            Validators.min(1),
            Validators.max(50),
          ]);
        break;
      case 'pesos':
        this.frmModifyAmount
          .get('amount')
          ?.setValidators([
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(11),
          ]);
        break;
      case 'porcentaje':
        this.frmModifyAmount
          .get('amount')
          ?.setValidators([
            Validators.required,
            Validators.maxLength(2),
            Validators.min(1),
            Validators.max(50),
            Validators.max(30),
          ]);
        break;
    }

    this.frmModifyAmount.get('amount')?.updateValueAndValidity();
  }
  closeModal(): void {
    sessionStorage.removeItem('newAmountCcv');
    sessionStorage.removeItem('newDiscountCcv');
    this.modalSvc.closeModal();
  }
  showConfirmationModal(): void {
    sessionStorage.setItem(
      'newAmountCcv',
      this.frmModifyAmount.get('amount')?.value
    );
    sessionStorage.setItem(
      'newDiscountCcv',
      this.frmModifyAmount.get('currency')?.value
    );
    sessionStorage.setItem(
      'newEmailCcv',
      this.frmModifyAmount.get('email')?.value
    );
    sessionStorage.setItem(
      'newRutCcv',
      this.frmModifyAmount.get('executiveRut')?.valid
        ? this.frmModifyAmount.get('executiveRut')?.value
        : '1-9'
    );
    this.modalSvc.openCustomModal({
      component: ConfirmationModalComponent,
      cssClass: 'apv-modal',
    });
  }

  updateDisbledFormButton(): string {
    if (
      this.frmModifyAmount.valid &&
      !(
        this.isDefaultAmmount() &&
        this.frmModifyAmount.get('currency')?.value === this.unitModify()
      )
    )
      return 'continue-subscription-button';
    return 'button-disable';
  }

  getDataFromStorage() {
    const subscriptionData = sessionStorage.getItem('subscriptionDataToModify');
    if (subscriptionData) {
      this.subscriptionDataToModify = JSON.parse(subscriptionData);
    }
  }
  getDataFromStorageAmount() {
    const subscriptionDataNew = sessionStorage.getItem('newAmountCcv');
    if (subscriptionDataNew) {
      this.newAmount = subscriptionDataNew;
    }
    const subscriptionDataDiscount = sessionStorage.getItem('newDiscountCcv');
    if (subscriptionDataDiscount) {
      this.newDiscount = subscriptionDataDiscount;
    }
  }

  closeOpenModal(): void {
    this.showConfirmationModal();
    this.modalSvc.closeModal();
  }
  showConfirmationWindow(): void {
    sessionStorage.setItem(
      'newAmountCcv',
      this.frmModifyAmount.get('amount')?.value
    );
    sessionStorage.setItem(
      'newDiscountCcv',
      this.frmModifyAmount.get('currency')?.value
    );
    sessionStorage.setItem(
      'newEmailCcv',
      this.frmModifyAmount.get('email')?.value
    );
    sessionStorage.setItem(
      'newRutCcv',
      this.frmModifyAmount.get('executiveRut')?.valid
        ? this.frmModifyAmount.get('executiveRut')?.value
        : '1-9'
    );

    this.showConfirmationWindowBool = true;
  }

  isDefaultAmmount() {
    return (
      this.frmModifyAmount.get('amount')?.value.replace('.', '') ===
      `${this.subscriptionDataToModify.discountValue}`.replace('.', '')
    );
  }

  get formInvalid() {
    return this.frmModifyAmount.get('amount')?.invalid ? 'on-label-error' : '';
  }
  public handleMailInputChange(): void {
    this.isModifySubscriptionButtonDisabled = this.frmModifyAmount.get('email')
      ?.invalid as boolean;
  }
  public addExecutiveHelp() {
    this.isExecutiveHelp = !this.isExecutiveHelp;
    if (this.isExecutiveHelp) {
      this.frmModifyAmount.addControl(
        'executiveRut',
        new FormControl(
          '',
          Validators.compose([
            Validators.required,
            customRutFormValidator,
            Validators.minLength(8),
            Validators.maxLength(13),
          ])
        )
      );
      this.frmModifyAmount.get('executiveRut')?.updateValueAndValidity();
    } else {
      this.frmModifyAmount.removeControl('executiveRut');
    }
  }
  removeDataFromStorage() {
    sessionStorage.removeItem('newAmountCcv');
    sessionStorage.removeItem('newDiscountCcv');
    sessionStorage.removeItem('newEmailCcv');
    sessionStorage.removeItem('newRutCcv');
  }
  get isSubmitButtonDisabled() {
    return (
      this.frmModifyAmount.invalid ||
      (this.isDefaultAmmount() &&
        this.frmModifyAmount.get('currency')?.value === this.unitModify())
    );
  }

  public getOutputVolverButton(event: any): void {
    this.showConfirmationWindowBool = false;
  }

  private setHelperTextDiscount(): void {
    switch (this.subscriptionDataToModify.discountType) {
      case 'U':
        this.helperTextCurrentDiscount = `Tu ahorro actual es de UF ${this.subscriptionDataToModify.discountValue}`;
        return;
      case 'P':{
        const numberWithDots = toClp(
          Number(this.subscriptionDataToModify.discountValue)
        );
        this.helperTextCurrentDiscount = `Tu ahorro actual es de $${numberWithDots}`;
        return;
      }
      case 'R':
        this.helperTextCurrentDiscount = `Tu ahorro actual es del ${this.subscriptionDataToModify.discountValue}% de tu sueldo`;
        return;

      default:
        this.helperTextCurrentDiscount = '';
    }
  }

  salir() {
    this.removeDataFromStorage();
    this.router.navigate(['/home/ccv/option-modify']);
  }

  public async mainVolverButton(): Promise<void> {
    const isFailedSubscription = await this.ionicStorage.get(
      IS_FAILED_SUBSCRIPTION
    );
    if (isFailedSubscription) {
      await this.ionicStorage.remove(IS_FAILED_SUBSCRIPTION);
      this.router.navigate(['/home/ccv/']);
    } else {
      this.router.navigate(['/home/ccv/detail']);
    }
  }
  get inputAmuntPlaceholderLabel(): string {
    switch (this.frmModifyAmount.get('currency')?.value) {
      case 'uf':
        return this.modifyAmount.placeHolderAmountInput;
      case 'pesos':
        return this.modifyAmount.placeHolderAmountInput;
      case 'porcentaje':
        return this.modifyAmount.placeHolderPercentageInput;
      default:
        return '';
    }
  }
  focusButtonSecondary() {
    this.isFocusButtonSecondary = !this.isFocusButtonSecondary;
  }
  focusRadioPills() {
    this.isFocusRadioPills = true;
  }
  blurRadioPills() {
    this.isFocusRadioPills = false;
  }
  isFocusRadioCurrencyPills(radioPills: string): boolean {
    return (
      this.isFocusRadioPills &&
      this.frmModifyAmount.get('currency')?.value === radioPills
    );
  }
  isClassLabelPlaceholderActive(): boolean {
    return (
      (this.frmModifyAmount.value.currency == 'porcentaje' &&
        this.isCurrencyFocused) ||
      (this.frmModifyAmount.value.currency == 'porcentaje' &&
        this.frmModifyAmount.get('amount')?.value)
    );
  }
  isFocusRadioExecutivePill() {
    this.isFocusReadioExecutive = !this.isFocusReadioExecutive;
  }
}
